import React from 'react';
import {Navigate} from 'react-router-dom';
import {useSuspension} from '../contexts/SuspensionContext';
import {rcic_account_suspended} from '../routing/LinkFactory';

interface SuspendedAccountGuardProps {
    children: React.ReactNode;
}

/**
 * SuspendedAccountGuard
 *
 * Wraps operational RCIC routes.  When the RCIC account is suspended (15-day
 * overdue threshold reached), it redirects to the Account Suspended page.
 *
 * Billing and payment routes are intentionally NOT wrapped by this guard so
 * that suspended RCICs can still access their invoices and complete payment.
 *
 * While the restriction status is still loading (brief initial fetch), children
 * are rendered normally to avoid a confusing flash redirect.
 */
const SuspendedAccountGuard: React.FC<SuspendedAccountGuardProps> = ({children}) => {
    const {isSuspended, isLoading} = useSuspension();

    // Don't redirect while we are still fetching the initial status.
    if (isLoading) return <>{children}</>;

    if (isSuspended) {
        return <Navigate to={rcic_account_suspended} replace/>;
    }

    return <>{children}</>;
};

export default SuspendedAccountGuard;
